import SidePanel from './SidePanel.connect';

export default SidePanel;
